import { motion } from "framer-motion";
import { EASE, MaskedLine } from "./Reveal";

export default function PageHero({ eyebrow, title, image, children, imgClassName = "object-center" }) {
  return (
    <section className="relative flex min-h-[62vh] items-end overflow-hidden bg-navy-900 pt-20">
      <div className="absolute inset-0 z-0">
        <img src={image} alt={title} className={`h-full w-full object-cover ${imgClassName}`} />
        <div className="absolute inset-0 bg-gradient-to-t from-navy-900 via-navy-900/55 to-navy-900/30" />
      </div>
      <div className="relative z-10 mx-auto w-full max-w-7xl px-5 pb-16 pt-28 sm:px-8 sm:pb-20">
        {eyebrow && (
          <div className="flex items-center gap-4">
            <span className="h-px w-10 bg-gold/70" aria-hidden="true" />
            <span className="text-[11px] font-semibold uppercase tracking-[0.3em] text-gold sm:text-xs">
              {eyebrow}
            </span>
          </div>
        )}
        <h1 className="mt-6 font-serif text-[clamp(2.4rem,6vw,4.8rem)] font-medium leading-[1.02] tracking-tight text-ivory">
          <MaskedLine delay={0.25}>{title}</MaskedLine>
        </h1>
        {children && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.55, ease: EASE }}
            className="mt-6 max-w-2xl text-sm font-light leading-relaxed text-ivory/85 sm:text-base"
          >
            {children}
          </motion.div>
        )}
      </div>
    </section>
  );
}
